'use strict'

import VideoViewer from './VideoViewer.vue'

const videoViewerPlugin = {
  install: function (Vue, options) {
    const ComponentClass = Vue.extend(VideoViewer)
    const instance = new ComponentClass()
    instance.$mount() // pass nothing
    document.body.appendChild(instance.$el)
    Vue.prototype.$d_videoViewer = instance
  }
}
export default videoViewerPlugin
